<template>
  <page-wrapper :title="title" :noPadBtm="true">
    <div class="d-flex justify-content-start" style="height: 100%">
      <home-list
        class="col-3 px-0 d-flex flex-column"
        v-model="project"
        @selectedHome=handleSelectedHome($event)
      ></home-list>
      <home-info
        class="col-6 px-0 d-flex flex-column"
        v-model="home"
      ></home-info>
      <activity-history
        class="col-3 px-0 d-flex flex-column"
        v-model="activityHistories"
      ></activity-history>
    </div>
  </page-wrapper>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies";
import PageWrapper from "@/lib/components/PageWrapper";
import { toCamelCaseObject } from "@/lib/util";
import HomeList from "../components/HomeList";
import HomeInfo from "../components/HomeInfo";
import ActivityHistory from "../components/ActivityHistory";

export default {
  components: {
    PageWrapper,
    HomeList,
    HomeInfo,
    ActivityHistory
  },
  data() {
    const project = {
      id: "",
      name: "",
      homes: [],
      stat: null
    };
    const home = null;
    const activityHistories = [];

    return {
      project,
      home,
      activityHistories
    };
  },
  created() {
    this.setup();
  },
  computed: {
    title() {
      return `ข้อมูลผู้ใช้ - รายละเอียดโครงการ ${this.project.name}`
    }
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {
      this.setupProject();
    },
    async setupProject() {
      const project = await this.fetchData();

      this.project = toCamelCaseObject(project);
    },
    async setupHome(id) {
      const home = await this.fetchHome(id);

      this.home = home;
    },
    async setupActivityHistories(id) {
      const activityHistories = await this.fetchActivityHistories(id);
      this.activityHistories = activityHistories;
    },
    async fetchData() {
      const { id } = this.$route.params;
      const response = await baanRueJaiClient.admin.residents.get(id);

      return response.data.result;
    },
    async fetchHome(id) {
      const response = await baanRueJaiClient.admin.memberManagement.homes.getHomeMembers(id);

      return response.data;
    },
    async fetchActivityHistories(id) {
      const response = await baanRueJaiClient.admin.memberManagement.homes.getHomeMembersHistory(id);

      return response.data;
    },
    handleSelectedHome(id) {
      this.setupHome(id);
      this.setupActivityHistories(id);
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.wrapper {
  padding: ($space / 2) $space;
}

</style>



// WEBPACK FOOTER //
// src/features/residents/pages/ResidentByProjectDetailPage.vue